import { postRESTParams, REMBLE_API_URL } from '.'

const BASE_PATH = `${REMBLE_API_URL}/users/profile`

/**
 * Updates user profile name and profile picture
 * @param {Strnig} name
 * @param {File} profilePicture
 */
const updateUserProfile = async (name, profilePicture = null) => {
  const url = `${BASE_PATH}/update`

  const formData = new FormData()

  formData.append('name', name)
  if (profilePicture) {
    formData.append('profile_picture', profilePicture)
  }

  const saved = await fetch(
    url,
    postRESTParams({ body: formData })
    ).catch(error => {
      console.error('error', error)
      return { error }
    })

    return saved
}

const updateUserPassword = async (password) => {
  const url = `${BASE_PATH}/update_password`
  const body = JSON.stringify({
    new_password: password
  })

  const saved = await fetch(
    url,
    postRESTParams(
      { body },
      { 'Content-Type': 'application/json' })
  ).catch(error => {
    console.error('error', error)
    return { error }
  })

  return saved
}

export {
  updateUserProfile,
  updateUserPassword
}